export default Object.freeze({
  TRANSFER: 'Paiement par virement',
  CHEQUE: 'Paiement par chèque',
  CARD: 'Paiement par carte de crédit',
});
